module.exports = __webpack_public_path__ + "4dfa25eba83b994b612f92dd47ac0e59.svg";